/* tslint:disable */
/* eslint-disable */

/**
 * 401130000 = Benutzer (Benutzer)
 * 
 * 401130001 = Administrator (Administrator)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAceBenutzerrolle {
 Benutzer = 401130000,
 Administrator = 401130001
}

marker([
    "Enum.GlobalEnumsAceBenutzerrolle.Benutzer",
    "Enum.GlobalEnumsAceBenutzerrolle.Administrator"
]);

export namespace GlobalEnumsAceBenutzerrolle
{
    class DataSets
    {
        static GlobalEnumsAceBenutzerrolleDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Benutzer", 401130000, "Benutzer"),
            new EnumValue("Administrator", 401130001, "Administrator"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAceBenutzerrolleDataSet;
    }
}
